// Dice coefficient over character bigrams: scores how similar two strings are, for ranking
// product-name suggestions and auto-mapping column headers.

function bigrams(value: string): Map<string, number> {
  const s = value.toLowerCase().replace(/\s+/g, ' ').trim();
  const map = new Map<string, number>();
  for (let i = 0; i < s.length - 1; i++) {
    const gram = s.slice(i, i + 2);
    map.set(gram, (map.get(gram) ?? 0) + 1);
  }
  return map;
}

/** 0..1 similarity between two strings (1 = identical). */
export function diceCoefficient(a: string, b: string): number {
  if (!a || !b) return 0;
  if (a === b) return 1;
  const ba = bigrams(a);
  const bb = bigrams(b);
  if (ba.size === 0 || bb.size === 0) return 0;

  let intersection = 0;
  let total = 0;
  for (const [gram, count] of ba) {
    total += count;
    const other = bb.get(gram);
    if (other) intersection += Math.min(count, other);
  }
  for (const count of bb.values()) total += count;
  return (2 * intersection) / total;
}
